import React from 'react';
import style from './tool-block-horizontal-style.module.scss';

function ToolBlockHorizontal(Props) {
   return (<div className={style.wrap}>{Props.tool_block.map(tool => (tool))}</div>);
}

export default ToolBlockHorizontal;